import { FormField, FormSelectField } from "@printtat/ui";
import type { ReactFormExtendedApi } from "@tanstack/react-form";
import { EGYPTIAN_GOVERNORATES } from "./constants";

/**
 * Catch-all TanStack Form React API type. `ReactFormExtendedApi` takes 12 generics
 * (form data shape + every validator slot); using `any` here matches the library's
 * own `AnyFieldApi`/`AnyFormApi` pattern.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyReactFormApi = ReactFormExtendedApi<any, any, any, any, any, any, any, any, any, any, any, any>;

interface AddressFormFieldsProps {
  form: AnyReactFormApi;
  disabled?: boolean;
}

export const AddressFormFields = ({
  form,
  disabled,
}: AddressFormFieldsProps) => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        form={form}
        name="fullName"
        label="Full Name"
        placeholder="Enter full name"
        required
        disabled={disabled}
      />
      <FormField
        form={form}
        name="phone"
        label="Phone Number"
        type="tel"
        placeholder="01X XXXX XXXX"
        prefix={<>+20</>}
        required
        disabled={disabled}
      />
    </div>

    <FormField
      form={form}
      name="addressLine1"
      label="Address Line 1"
      placeholder="Street address, building number"
      required
      disabled={disabled}
    />

    <FormField
      form={form}
      name="addressLine2"
      label="Address Line 2"
      placeholder="Apartment, floor, etc. (optional)"
      disabled={disabled}
    />

    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4">
      <FormField
        form={form}
        name="city"
        label="City"
        placeholder="City"
        required
        disabled={disabled}
      />

      <FormSelectField
        form={form}
        name="governorate"
        label="Governorate"
        placeholder="Select governorate"
        options={EGYPTIAN_GOVERNORATES.map((gov) => ({
          value: gov,
          label: gov,
        }))}
        required
        disabled={disabled}
      />

      <FormField
        form={form}
        name="postalCode"
        label="Postal Code"
        placeholder="Optional"
        disabled={disabled}
      />
    </div>
  </div>
);
